import React from "react";
import { connect } from 'react-redux';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useLocation, Link } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress'
import { Helmet } from "react-helmet";
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import axios from 'axios';
import moment from 'moment';
import { Container, Row, Col, Form, FormGroup, InputGroupAddon, InputGroupText, Input,Button, InputGroup,} from "reactstrap";

import Event from "components/Self/AdminEvent.js";

import Tooltip from '@material-ui/core/Tooltip'

import { withStyles } from "@material-ui/core/styles";

const CTooltip = withStyles({ tooltip: { fontSize: "14px", padding: '7px', } })(Tooltip);

const Index = (props) => {
    const location = useLocation();
    const [sendingdata, setSendingdata] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [tt, settt] = React.useState('');
    const [active, setActive] = React.useState(false);
    const [mess, setmess] = React.useState('');
    if (location) {
        // console.log('yes location of events')
        // console.log(location);
        // console.log(location.state);
        if (location.state != null) {
            if (location.state.token) {
                if (location.state.token === 1) {
                    console.log(location.state.message);
                    setSendingdata(location.state.message)
                    settt(location.state.type);
                    setOpen(true);
                    location.state.token -= 1;
                }
            }
        }

    }
    else {
        // console.log('nope')
    }

    const handleClose = (event, reason) => {
        setOpen(false);
    };
    let [responseData, setResponseData] = React.useState([]);
    const fetchData = React.useCallback(() => {
        axios.get(process.env.REACT_APP_DOMAIN+"/events", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                response.data.map(function (responseData, index) {
                    responseData.edate2 = moment(responseData.edate).fromNow()
                    responseData.edate = moment(responseData.edate).format('Do MMM YYYY')
                    // responseData.date = moment(responseData.date).format('Do MMM YYYY')
                    responseData.tfrom = moment(responseData.tfrom, "HH:mm:ss").format("hh:mm A")
                    responseData.tto = moment(responseData.tto, "HH:mm:ss").format("hh:mm A")
                    // console.log(responseData.edate2)
                    return(null)
                })

                setResponseData(response.data)
                // console.log(response.data)
                setActive(true)
                if(response.data.length < 1){
                    setmess("No Events Found")
                }
            })
            .catch((error) => {
                console.log(error)
                setSendingdata('Something went Wrong')
                settt('error')
                setOpen(true)
                setmess("Something went wrong, make sure you're Internet is turned on")
            })

    }, [props.token])
    React.useEffect(() => {
        fetchData()
        document.title = "Current Events "
    }, [fetchData])

    const focus = (e) => {
        // console.log('yes')
        e.target.style.width = '200px'
        e.target.style.width = '500px'
        // e.target.style.backgroundColor = 'cyan'
    };

    const blur = (e) => {
        // console.log('yes')
        e.target.style.width = '200px'
        // e.target.style.backgroundColor = 'cyan'
    };

    const handleOnChange = (event) => {
        // console.log(event.target.value)
        if (event.target.value <= 0) {
            fetchData()
            return 0;
        }

        var input = event.target.value.toLowerCase();
        let x = document.getElementsByClassName('searchelementall');
        // console.log(x.length)
        for (i = 0; i < x.length; i++) {
            if (!x[i].innerHTML.toLowerCase().includes(input)) {
                x[i].style.display = "none";
            }
            else {
                x[i].style.display = "list-item";
            }
        }
        // var url = process.env.REACT_APP_DOMAIN+"/events/" + event.target.value
        // console.log(url)
        // axios.get(url)
        //     .then((response) => {
        //         setResponseData(response.data)
        //         console.log(response.data)
        //         // console.log(response.data[5].title)
        //         // console.log(response.data[5].poster)

        //     })
        //     .catch((error) => {
        //         console.log(error)
        //         setSendingdata('Something went Wrong')
        //         settt('error')
        //         setOpen(true)
        //         setmess("Something went wrong, there are no events with this")
        //     })
    };

    if (responseData) {
        for (var i = 0; i < responseData.length; i++) {
            if (responseData[i].poster) {
                if (responseData[i].poster.charAt(0) === '/') {
                    responseData[i].poster = process.env.REACT_APP_DOMAIN+"" + responseData[i].poster;
                }
            }
            if (responseData[i].poster2) {
                if (responseData[i].poster2.charAt(0) === '/') {
                    responseData[i].poster2 = process.env.REACT_APP_DOMAIN+"" + responseData[i].poster2;
                }
            }
            if (responseData[i].poster3) {
                if (responseData[i].poster3.charAt(0) === '/') {
                    responseData[i].poster3 = process.env.REACT_APP_DOMAIN+"" + responseData[i].poster3;
                }
            }

        }
    }

    return (
        <>
            <div className="header bg-gradient-bluec pb-7 pt-1 pt-md-8 back ">
                <Container fluid>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <meta name="theme-color" content="#00ffff" />
                        <meta name="description" content={'Current Running Events: Edit, View, Comment, Register, Add Report'} />
                        <meta property="og:description" content={'Current Running Events: Edit, View, Comment, Register, Add Report'} />
                        <meta property="og:title" content='DepAct' />
                        <meta property="og:type" content="Events" />
                        <meta property="og:url" content={"https://depact-kjsieit.vercel.app/main/events"} />
                    </Helmet>
                    <div className="header-body">
                        <Row className="bg-greenc mobile-sm-mt">
                            <Col xl="8" lg="8" md="8" sm="8" xs="6" className="bg-yellowc" style={{}}>
                            <Form className="form-inline ml- mr-3 bg-pinkc d-md-flex mobile-no-mt">
                                <FormGroup className="mb-0 ">
                                    <InputGroup className={"input-group-alternative border-" + props.theme} style={{ borderRadius: '30px' }}>
                                        <InputGroupAddon addonType="prepend" style={{ borderLeftTopRadius: '30px', borderLeftBottomRadius: '30px' }}>
                                            <InputGroupText className={"pt-3 inputbg-" + props.theme + " pb-3 pl-3"} style={{ borderTopLeftRadius: '30px', borderBottomLeftRadius: '30px' }}>
                                                <i className={"fas fa-search texts-" + props.theme} style={{ borderLeftTopRadius: '30px', borderLeftBottomRadius: '30px' }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                            <Input placeholder={"Search Events"} className={"pt-3 pb-3 inputbg-" + props.theme + " texts-" + props.theme} type="text" onFocus={(window.innerWidth < 790 ? null : focus)} onBlur={(window.innerWidth < 790 ? null : blur)} onChange={handleOnChange} style={{ height: '100%', borderTopRightRadius: '30px', borderBottomRightRadius: '30px' }} />
                                    </InputGroup>
                                </FormGroup>
                            </Form>
                            </Col>
                            {(props.adminValue ? 
                                <Col xl="4" lg="4" md="4" sm="4" xs="6" >
                                    <CTooltip arrow title={'View Finished Events'} placement="top">
                                    <Link to='finished-events'>
                                        <Button className="alag-fab" >Finished</Button>
                                    </Link></CTooltip>
                                    <Link to='add-event'>
                                        <CTooltip arrow title={'Add an Event'} placement="top">
                                    <IconButton disableRipple color="" className="ml-3 alag-fabc bg-white text-dark" size="medium" aria-label="add" >
                                        <AddIcon />
                                    </IconButton></CTooltip>
                                    </Link>
                                </Col>
                                :
                                null
                            )}
                        </Row>
                    </div>
                </Container>
            </div>
            {!active &&
                <div className="pb-7 pt-1 pt-md-7 justify-content-center text-center" style={{ backgroundColor: '' }}>
                    <CircularProgress color="info" className={"mt-7 textb-" + props.theme} />
                    <h4 className={"mt-7 textb-" + props.theme}>{mess}</h4>
                </div>

            }
            {active &&
                <Container className="mt--5" fluid>
                    <div className="header-body">
                        <Row className="bg-greenc mobile-no-mtc">
                            <Col xl="12" lg="12" md="12" className="bg-yellowc" style={{  }}>
                                <Row>
                                    {responseData.map(function (responseData, index) {
                                        return (
                                            <Col xl="12" lg="12" md="12" sm="12" className="searchelementall ml- mr-10 mt-4 mobile-no-ml">
                                                <Event fetchData={fetchData} fetch={props.fetch} event={responseData} />
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    <div className="pb-7 pt-1 pt-md-7 justify-content-center text-center" style={{ backgroundColor: '' }}>
                        <h4 className={"mt-7 textb-" + props.theme}>{mess}</h4>
                    </div>
                </Container>
            }
            <Container className="mt-0" fluid>
                <Row>
                </Row>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Index);
